import { useEffect } from 'react';
import { createApiKeyHandler } from '../utils/ia-api-key-manager.js';
import debug from '@commons-shared/debug';
import { config } from '../config/environment';

export const useApiKeyHandlers = (
  textAiApiKeyValue,
  visionAiApiKeyValue,
  translationAiApiKeyValue,
  setEncryptedApiKey,
  showSuccess,
  showError,
  t,
  selectedModels = {} // { textModelName, visionModelName, translationModelName }
) => {
  // Créer les gestionnaires spécialisés pour chaque type d'IA
  const saveAndTestTextApiKey = createApiKeyHandler(
    '/api/ia/text',
    setEncryptedApiKey,
    showSuccess,
    showError,
    t,
    selectedModels.textModelName
  );

  const saveAndTestVisionApiKey = createApiKeyHandler(
    '/api/ia/vision',
    setEncryptedApiKey,
    showSuccess,
    showError,
    t,
    selectedModels.visionModelName
  );

  const saveAndTestTranslationApiKey = createApiKeyHandler(
    '/api/ia/translation',
    setEncryptedApiKey,
    showSuccess,
    showError,
    t,
    selectedModels.translationModelName
  );

  return {
    saveAndTestTextApiKey: () => saveAndTestTextApiKey(textAiApiKeyValue),
    saveAndTestVisionApiKey: () => saveAndTestVisionApiKey(visionAiApiKeyValue),
    saveAndTestTranslationApiKey: () => saveAndTestTranslationApiKey(translationAiApiKeyValue)
  };
};
